import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import { INTERP } from '../../../constants/shared/CommonConstants';

const { RED } = INTERP;

const getPmInterp = (score, grade, period, measure, pmThresholdsMapper) => {
    const thresholds = get(pmThresholdsMapper, `${grade}.${period}.${measure}`, []);
    return isEmpty(thresholds)
        ? null
        : get(
              thresholds.find(threshold => score >= threshold.score),
              'interp',
              RED,
          );
};

export default getPmInterp;
